// @flow

import * as React from 'react';
import classNames from 'classnames';
import * as css from './OneVotingPopupRestriction.scss';

type Props = {
	isShow: boolean,
};

const OneVotingPopupRestriction = ({ isShow }: Props) => {
	return (
		<div className={classNames(css.oneVotingPopupRestriction, isShow && css.show)}>
			<div className={css.oneVotingPopupRestrictionContent}>ניתן להצביע רק פעם אחת. תודה רבה על השתתפותכם!</div>
		</div>
	);
};

export { OneVotingPopupRestriction };
